export type TEmailValidationError = 'INVALID_EMAIL' | 'TOO_MANY_EMAILS'

// mirrors the create route's request schema: z.array(z.string().email()).max(10)
export const MAX_EMAIL_RECIPIENTS = 10

export const splitEmails = (emailString: string): string[] =>
  emailString
    .split(',')
    .map((email) => email.trim())
    .filter((email) => email.length > 0)

export const validateEmails = (emailString: string): TEmailValidationError | null => {
  const emailList = splitEmails(emailString)

  if (emailList.length > MAX_EMAIL_RECIPIENTS) return 'TOO_MANY_EMAILS'

  const emailRegex = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/

  return emailList.some((email) => !emailRegex.test(email)) ? 'INVALID_EMAIL' : null
}
